import { render } from "./NoticeBox.vue?vue&type=template&id=03e5dd72&scoped=true"
import script from "./NoticeBox.vue?vue&type=script&lang=ts"
export * from "./NoticeBox.vue?vue&type=script&lang=ts"

import "./NoticeBox.vue?vue&type=style&index=0&id=03e5dd72&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-03e5dd72"

export default script